module.exports = __webpack_public_path__ + "assets/fa-brands-400.0cb5a5c0d251c109458c85c6afeffbaa.svg";